/**
 * Extract whitelist array. Used by set and string matchers
 */
export function setTransform(whitelistObject) {
    return whitelistObject.whitelist;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/evaluator/matchersTransform/set.js
// module id = 3869
// module chunks = 25